import PageHeader from "../components/homepage/PageHeader";
import NotFoundSection from "../components/NotFoundSection";

function NotFound() {
  return (
    <>
      <PageHeader title={'404 Page'} />
      <NotFoundSection  />
    </>
  );
}

export default NotFound;
